import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["data-target", "aria-controls"]
const _hoisted_3 = ["textContent"]
const _hoisted_4 = ["id", "aria-labelledby"]
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = { class: "mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_setting_panel = _resolveComponent("setting-panel")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "card-header",
      id: 'soneki-keisan-item-header-' + _ctx.item.item.id
    }, [
      _createElementVNode("button", {
        class: "btn btn-link",
        type: "button",
        "data-toggle": "collapse",
        "data-target": '#soneki-keisan-item-' + _ctx.item.item.id,
        "aria-expanded": "false",
        "aria-controls": 'soneki-keisan-item-' + _ctx.item.item.id
      }, [
        _createElementVNode("span", {
          textContent: _toDisplayString(_ctx.item.item.kmkName)
        }, null, 8, _hoisted_3)
      ], 8, _hoisted_2)
    ], 8, _hoisted_1),
    _createElementVNode("div", {
      id: 'soneki-keisan-item-' + _ctx.item.item.id,
      class: "collapse",
      "aria-labelledby": 'soneki-keisan-item-header-' + _ctx.item.item.id
    }, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_setting_panel, {
            class: "mt-3",
            "response-setting-item": _ctx.item.item.setting,
            "panel-name": "dummy",
            onUpdateSettingItem: _ctx.onUpdateKmk
          }, null, 8, ["response-setting-item", "onUpdateSettingItem"])
        ])
      ])
    ], 8, _hoisted_4)
  ]))
}